import React, { useEffect, useState } from 'react';
import { Table, Tag, Button, Typography, Space, message } from 'antd';
import { BellOutlined, CheckOutlined, MailOutlined, WechatOutlined, LaptopOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { notificationApi } from '../../services/api';
import dayjs from 'dayjs';

const { Title, Text } = Typography;

const channelIcons = {
  wecom: <WechatOutlined style={{ color: '#07c160' }} />,
  email: <MailOutlined style={{ color: '#fa8c16' }} />,
  system: <LaptopOutlined style={{ color: '#1677ff' }} />,
};

const channelLabels = {
  wecom: '企业微信',
  email: '邮件',
  system: '站内信',
};

export default function NotificationsPage() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });

  const fetchNotifications = async (page = 1, pageSize = 20) => {
    setLoading(true);
    try {
      const res = await notificationApi.list({ page, pageSize });
      setData(res.list || []);
      setPagination({ current: res.page, pageSize: res.pageSize, total: res.total });
    } catch (e) {
      message.error(e?.error || '加载通知失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const handleMarkRead = async (id) => {
    try {
      await notificationApi.markRead(id);
      setData(prev => prev.map(n => n.id === id ? { ...n, read: true } : n));
    } catch (e) {
      message.error('操作失败');
    }
  };

  const handleTableChange = (pag) => {
    fetchNotifications(pag.current, pag.pageSize);
  };

  const columns = [
    {
      title: '',
      dataIndex: 'read',
      width: 40,
      render: (read) => !read && <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#1677ff' }} />,
    },
    {
      title: '渠道',
      dataIndex: 'channel',
      width: 80,
      render: (ch) => (
        <Space>
          {channelIcons[ch] || channelIcons.system}
          <Text style={{ fontSize: 12 }}>{channelLabels[ch] || ch}</Text>
        </Space>
      ),
    },
    {
      title: '标题',
      dataIndex: 'title',
      render: (title, record) => (
        <div>
          <Text strong={!record.read} style={{ fontSize: 14 }}>{title}</Text>
          <div style={{ fontSize: 13, color: '#666', marginTop: 2 }}>{record.content}</div>
        </div>
      ),
    },
    {
      title: '时间',
      dataIndex: 'sentAt',
      width: 160,
      render: (val) => (
        <Text type="secondary" style={{ fontSize: 13 }}>
          {dayjs(val).format('YYYY-MM-DD HH:mm')}
        </Text>
      ),
    },
    {
      title: '状态',
      dataIndex: 'read',
      width: 100,
      render: (read) => (
        read ? <Tag>已读</Tag> : <Tag color="blue">未读</Tag>
      ),
    },
    {
      title: '操作',
      width: 120,
      render: (_, record) => (
        <Space>
          {!record.read && (
            <Button type="link" size="small" icon={<CheckOutlined />}
              onClick={() => handleMarkRead(record.id)}>
              标为已读
            </Button>
          )}
          {record.link && (
            <Button type="link" size="small"
              onClick={() => navigate(record.link)}>
              查看
            </Button>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Title level={4} style={{ marginBottom: 24 }}>
        <BellOutlined style={{ marginRight: 8 }} />
        通知中心
      </Title>

      <Table
        dataSource={data}
        columns={columns}
        rowKey="id"
        loading={loading}
        pagination={{
          ...pagination,
          showSizeChanger: true,
          showTotal: (total) => `共 ${total} 条通知`,
        }}
        onChange={handleTableChange}
        locale={{ emptyText: '暂无通知' }}
      />
    </div>
  );
}
